var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row flex__center mb-5 py-5"},[_c('div',{staticClass:"col-sm-12 col-md-8 col-lg-5 text-center"},[_c('img',{attrs:{"src":"/assets/img/icons/empty.svg","alt":""}}),(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.text)?_c('p',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }